import { request } from './client';

export const orgService = {
  getGroups: () => request('/groups'),
  
  getOrganisations: () => request('/organisations'),
  
  addOrganisation: (orgData) => request('/organisations', { method: 'POST', body: orgData }),
  
  updateOrganisation: (id, orgData) => request(`/organisations/${id}`, { method: 'PUT', body: orgData }),
  
  deleteOrganisation: (id) => request(`/organisations/${id}`, { method: 'DELETE' }),
  
  deleteOrganisationsBulk: (ids) => request('/organisations/bulk-delete', { method: 'POST', body: { ids } }),
  
  getUsersByOrganisation: (orgId) => request(`/organisations/${orgId}/users`),
  
  importOrganisations: (formData) => request('/organisations/import', { method: 'POST', body: formData }),

  exportOrganisations: async () => {
    // Request the file as a blob using your custom client
    const blob = await request('/organisations/export-index', { method: 'GET', isBlob: true });
    
    // Create a download link and trigger it
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Organisations_List_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },
};
